import {
    CollapseMinusBox,
    CollapsePlusBox,
    ExpandIcon,
    ReloadIcon
} from 'common/components/icons';

import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import CudaPaper from 'common/components/CudaPaper';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import React from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    container: {
        padding: '10px 1px',
        alignSelf: 'flex-start'
    },
    emptyTableCell: {
        textAlign: 'center',
        fontSize: '16px',
        color: '#777777',
        fontWeight: '300',
        height: '200px',
    },
    actionHeadCell: {
        width: '100px',
        textAlign: 'center'
    },
    actionCell: {
        display: 'flex',
        justifyContent: 'center'
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    reloadButtonDiv: {
        margin: 0,
    },
    actions: {
        padding: 0
    },
    level: {
        marginLeft: '30px',
        padding: '5px 0'
    },
    item: {
        borderBottom: '1px solid #5d5d5d8a',
    },
    item_red: {
        borderBottom: '1px solid #5d5d5d8a',
        background: '#fb4040',
    },
    item_gray: {
        borderBottom: '1px solid #5d5d5d8a',
        background: '#bbbbbb',
    },
    dc: {
        padding: '10px',
        cursor: 'pointer',
        '& svg': {
            verticalAlign: 'bottom',
            marginBottom: '3px',
        },
    },
    esxi: {
        margin: '5px 0',
        padding: '0 10px',
    },
    cwaf: {
    },
    service: {
        extend: 'level',
    },
    esxiOpen: {
        padding: '10px',
        marginLeft: '30px',
        cursor: 'pointer',
        '& svg': {
            verticalAlign: 'bottom'
        },
    },
    u: {
        padding: '5px'
    },
    not_active: {
        extend: 'dc',
        background: '#ffff39',
    },
    under_maintenance: {
        extend: 'dc',
        background: '#ffce75',
    },
    not_normal: {
        extend: 'dc',
        background: '#fb4040',
    },
    dc_id: {
        fontSize: '17px',
    },
    collapseBox: {
        marginRight: '5px'
    }
}

class Dashboard extends React.Component {
    state = {
        expanded: true,
        tree: {}
    };

    handleExpandClick = (key) => {
        this.setState(state => ({ expanded: !state.expanded }));
    };

    handleExpandTree = (key) => {
        this.setState(state => ({
            tree: {
                ...state.tree,
                [key]: !state.tree[key]
            }
        }));
    };

    isExpanded = (key) => {
        return this.state.tree[key]
    };

    render() {
        const { classes, isLoading, items, reload, } = this.props;

        return (
            <Grid className={classes.container}>
                <CudaPaper loading={isLoading} padding>
                    <CardActions className={classes.actions} disableactionspacing="true">
                        Server Tree

          <Button className={classes.button} onClick={reload}>
                            <ReloadIcon />
                        </Button>

                        <IconButton
                            className={classnames(classes.expand, {
                                [classes.expandOpen]: this.state.expanded,
                            })}
                            onClick={this.handleExpandClick}
                            aria-expanded={this.state.expanded}
                            aria-label="Show more"
                        >
                            <ExpandIcon />
                        </IconButton>
                    </CardActions>

                    <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
                        <Grid item xs={12} className={classes.tableContainer}>
                            <u>DCs:</u>
                            {
                                items.map((item, i) => {

                                    const not_active = item.esxis.some(iesxi => !iesxi.is_active)
                                    let not_normal = item.esxis.some(iesxi => iesxi.cwafs.some(icwaf => icwaf.vm_state !== 'NORMAL' || icwaf.lb_status !== 'NORMAL'))
                                    let itemClass = classes.item

                                    const under_maintenance = item.under_maintenance
                                    let dcClassName = 'dc'
                                    if (under_maintenance) {
                                        dcClassName = 'under_maintenance'
                                    } else if (!item.is_bgp_active) {
                                        itemClass = classes.item_red
                                        not_normal = true

                                        if (item.datacenter_id === 'dcfa' || item.datacenter_id === '1abb') {
                                            itemClass = classes.item_gray
                                            not_normal = true
                                        }
                                    }

                                    let backgroundFill = '#fff'
                                    if (under_maintenance) {
                                        backgroundFill = '#ffce75'
                                    } else if (not_active) {
                                        backgroundFill = '#ffff39'
                                    } else if (not_normal) {
                                        backgroundFill = '#fb4040'
                                    }

                                    return (
                                        <div key={i} className={itemClass}>
                                            <div
                                                onClick={() => { this.handleExpandTree('dc' + i) }}
                                                aria-expanded={this.isExpanded('dc' + i)}
                                                aria-label="Show more"
                                                className={classes[dcClassName]}
                                            >
                                                {this.isExpanded('dc' + i) &&
                                                    <CollapseMinusBox className={classes.collapseBox} color='#000' backgroundFill={backgroundFill} />
                                                }

                                                {!this.isExpanded('dc' + i) &&
                                                    < CollapsePlusBox className={classes.collapseBox} color='#000' backgroundFill={backgroundFill} />
                                                }
                                                Datacenter ID: <b className={classes.dc_id}>{item.datacenter_id}</b>
                                                {item.description &&
                                                    <span>
                                                        &nbsp;&nbsp;
                                    Description: <b>{item.description}</b>
                                                    </span>
                                                }
                                                <span>
                                                    &nbsp;&nbsp;
                                    Is Bgp Active: <b>{item.is_bgp_active ? 'true' : 'false'}</b>
                                                </span>
                                                &nbsp;&nbsp;
                                    Under Maintenance: <b>{item.under_maintenance ? 'true' : 'false'}</b>
                                            </div>
                                            <Collapse in={this.isExpanded('dc' + i)} timeout="auto" unmountOnExit>
                                                <div>
                                                    {
                                                        item.esxis.map((iesxi, ei) => {
                                                            const not_active = !iesxi.is_active
                                                            return (
                                                                <div key={ei}>
                                                                    <div
                                                                        onClick={() => { this.handleExpandTree('esxi' + i + ei) }}
                                                                        aria-expanded={this.isExpanded('esxi' + i + ei)}
                                                                        aria-label="Show more"
                                                                        className={classes.esxi}
                                                                    >
                                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <u className={classes.u}>ESXIs:</u>
                                                                        Hostname: <b>{iesxi.hostname}</b>
                                                                        &nbsp;&nbsp;
                                            {iesxi.is_active !== null &&
                                                                            <span>Is Active: <b>{iesxi.is_active ? 'true' : 'false'}</b></span>
                                                                        }
                                                                    </div>

                                                                    <div key={ei}>
                                                                        {
                                                                            iesxi.cwafs.map((icwaf, ci) => {
                                                                                const not_normal = icwaf.vm_state !== 'NORMAL' || icwaf.lb_status !== 'NORMAL'
                                                                                const cwafClassName = not_active ? 'not_active' : not_normal ? 'not_normal' : 'esxi'

                                                                                return (

                                                                                    <div key={ci} className={classes[cwafClassName]}>
                                                                                        <div
                                                                                            onClick={() => { this.handleExpandTree('cwaf' + i + ei + ci) }}
                                                                                            aria-expanded={this.isExpanded('cwaf' + i + ei + ci)}
                                                                                            aria-label="Show more"
                                                                                            className={classes.header}
                                                                                        >
                                                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        Hostname: <b>{icwaf.hostname}</b>
                                                                                            &nbsp;&nbsp;
                                                        Lb Status: <b>{icwaf.lb_status}</b>
                                                                                            &nbsp;&nbsp;
                                                        VM State: <b>{icwaf.vm_state}</b>
                                                                                            &nbsp;&nbsp;
                                                        WAF serial: <b>{icwaf.serial}</b>
                                                                                            &nbsp;&nbsp;
                                                        Version: <b>{icwaf.version}</b>
                                                                                            &nbsp;&nbsp;
                                                        Configured services: <b>{icwaf.configured_count}/{icwaf.all_services_count} ({icwaf.configure_progress}%)</b>
                                                                                        </div>
                                                                                    </div>)
                                                                            })
                                                                        }

                                                                    </div>

                                                                </div>)
                                                        })
                                                    }
                                                </div>
                                            </Collapse>
                                        </div>
                                    )
                                })
                            }
                        </Grid>
                    </Collapse>

                </CudaPaper>
            </Grid>
        )
    };
};

export default withStyles(styles)(Dashboard);